import { render, staticRenderFns } from "./LA.vue?vue&type=template&id=16bec4ad&"
import script from "./LA.vue?vue&type=script&lang=js&"
export * from "./LA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports